import { ref } from 'vue';

// Estado compartido de actualización del service worker.
// registerServiceWorker.js marca cuando hay una versión nueva esperando;
// el banner (UpdateBanner) y el hook de rutas (main.js) la aplican.

export const updateDisponible = ref(false);

let swEnEspera = null;
let listenerRegistrado = false;
let recargando = false;

export function marcarActualizacionPendiente(registration) {
  swEnEspera = registration?.waiting || null;
  updateDisponible.value = !!swEnEspera;
}

export function aplicarActualizacion() {
  if (!swEnEspera) return;

  if (!listenerRegistrado && 'serviceWorker' in navigator) {
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (recargando) return;
      recargando = true;
      window.location.reload();
    });
    listenerRegistrado = true;
  }

  // El SW generado por Workbox escucha este mensaje y hace skipWaiting();
  // al activarse dispara controllerchange y ahí se recarga (una sola vez).
  swEnEspera.postMessage({ type: 'SKIP_WAITING' });
}
